import { TreeNode } from 'primeng/api';
import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';
import { AddressType } from './address-type.model';

export class LocationCriteria extends FilterCriteria {
  public override title = 'Location';
  public override type: FilterTypes = FilterTypes.Location;
  locationSelection: TreeNode[] = [];
  locationSelectionId: string[] = [];
  addressType?: AddressType = null;

  public override validate(): boolean {
    return this.locationSelection != null && this.locationSelection.length > 0;
  }

  public override toString(): string {
    const selection = this.locationSelection ? this.locationSelection.map((selection) => selection.label).join(', ') : '<null>';

    if (this.addressType === null) {
      return `Location: ${selection}`;
    }

    const type = this.addressType === AddressType.IncorporationAddress ? 'Incorporation Address' : 'Trading Address';
    return `${type} | Location: ${selection}`;
  }
}
